var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c(
          "b-container",
          { attrs: { fluid: "" } },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "10", "offset-md": "1" } },
                  [
                    _c("back-button"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "panel21 panel-default" },
                      [
                        _c("div", { staticClass: "panel-heading" }, [
                          _c(
                            "h4",
                            { staticClass: "content-block labelAccordionForm" },
                            [
                              _vm.details.direction === "0"
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "formIcon",
                                      attrs: {
                                        src: require("../../../../assets/static/images/icons/inbox_into.png"),
                                      },
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("received.rcvd_verb_past_DP")
                                        ) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.details.direction === "1"
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "formIcon",
                                      attrs: {
                                        src: require("../../../../assets/static/images/icons/inbox_out.png"),
                                      },
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("sent.snt_verb_past", {
                                            itemname: _vm.$t(
                                              this.$engine.services.getSingularNameFromServiceId(
                                                this.$engine.user.currentService
                                                  .id
                                              )
                                            ),
                                          })
                                        ) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("direct-payment-details", {
                          attrs: {
                            payment: _vm.details,
                            showMainDetails: true,
                          },
                        }),
                        _vm._v(" "),
                        _vm.details.validators.length > 0
                          ? _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t(
                                    "common.formsSubTitle.dir_pymnt_val_hstry"
                                  ),
                                },
                              },
                              [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "table",
                                      {
                                        staticClass:
                                          "table table-striped table-bordered table-status-history",
                                      },
                                      [
                                        _c(
                                          "thead",
                                          { staticClass: "thead-dark" },
                                          [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                { attrs: { scope: "col" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "common.group_label"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                { attrs: { scope: "col" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("common.vldt_user")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                { attrs: { scope: "col" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("common.date_vldt")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "tbody",
                                          _vm._l(
                                            _vm.sortedValidators,
                                            function (validator) {
                                              return _c(
                                                "tr",
                                                { key: validator.groupLabel },
                                                [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "longword dateTimehistoryHeight",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          validator.groupLabel
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "longword dateTimehistoryHeight",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            validator.identifier
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "showLargeScreenOnly dateTimehistoryHeight",
                                                      staticStyle: {
                                                        "padding-right": "30px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatDateTime"
                                                          )(
                                                            validator.horodatage
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "showSmallScreenOnly",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatDateTime"
                                                          )(
                                                            validator.horodatage
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.details.direction === "0" && _vm.details.status === "0"
              ? _c("div", { staticClass: "inboxDetailButton" }, [
                  _c("div", { staticClass: "row justify-content-start" }, [
                    _c(
                      "div",
                      {
                        staticClass: "offset-md-5 col-md-3",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button-action firstButtonMarginTop milkyBlockBlack",
                            attrs: { round: "", disabled: !_vm.canAccept },
                            on: {
                              click: function ($event) {
                                return _vm.answerDP(true)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "icon fa fa-paper-plane" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.accpt")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-3",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button-action firstButtonMarginTop milkyBlockBlack",
                            attrs: { round: "", disabled: !_vm.canRefuse },
                            on: {
                              click: function ($event) {
                                return _vm.answerDP(false)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "icon fa fa-hand-stop-o" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.refus")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "toolbarPageBottomBlank" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }